import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState, UpdateSchemaItem } from './schema';
import { RootStoreType } from '../rootReducer';
import { StructureColumnTypeEnum, SchemaItem, StructureItemType } from '../../@shared/Models/Models';

const statesSlice = createSlice({
    name: 'modelReducer',
    initialState: initialState.schema,
    reducers: {
        setIsShowSchemaModal: (state, action: PayloadAction<boolean>) => {
            state.isShowModal = action.payload;
        },
        setSchemaName: (state, action: PayloadAction<string>) => {
            state.name = action.payload;
        },
        setSchemaDescription: (state, action: PayloadAction<string>) => {
            state.description = action.payload;
        },
        setSchemaId: (state, action: PayloadAction<string>) => {
            state.id = action.payload;
        },
        updateSchemaItems: (state, action: PayloadAction<UpdateSchemaItem>) => {
            state.schema[action.payload.index] = action.payload;
        },
        setSchemaItems: (state, action: PayloadAction<SchemaItem[]>) => {
            state.schema = action.payload;
        },
        removeSchemaItems: (state, action: PayloadAction<number>) => {
            state.schema = state.schema.filter((x, i) => i !== action.payload);
        },
        addEmptySchemaItem: (state) => {
            state.schema.push({ name: "", valueTypeId: StructureItemType.Number, typeId: StructureColumnTypeEnum.Feature } as SchemaItem);
        },
        cleanSchema: (state) => {
            state.schema = [];
            state.name = "";
            state.id = "";
            state.description = "";

        }
    }
});

export const {
    setIsShowSchemaModal,
    addEmptySchemaItem,
    updateSchemaItems,
    setSchemaName,
    setSchemaDescription,
    removeSchemaItems,
    cleanSchema,
    setSchemaId,
    setSchemaItems
} = statesSlice.actions;

//selectors
export const getIsShowModelModal = (store: RootStoreType): boolean => store.schemaState.schema.isShowModal;
export const getModelName = (store: RootStoreType): string => store.schemaState.schema.name;
export const getModelDescription = (store: RootStoreType): string => store.schemaState.schema.description;
export const getModelId = (store: RootStoreType): string => store.schemaState.schema.id;
export const getSchemaItems = (store: RootStoreType): SchemaItem[] => store.schemaState.schema.schema;

export default statesSlice.reducer;